
























































































































import { PublishmentCourse } from "@/interfaces/publishmentcourse";
import AppFormLogicMixin from "@/plugins/AppFormLogicMixin";
import Vue from "vue";
export default Vue.extend({
  mixins: [AppFormLogicMixin],
  methods: {
    async onComplete() {
      this.$router.push({
        name: "AdministratorCoursesComplete",
        params: {
          id: this.$route.params.id
        }
      });
    },
    async decoratePostData(postData: PublishmentCourse) {
      postData.days = parseInt("" + postData.days, 10);
      if (!postData.days) {
        postData.days = undefined;
      }

      postData.months = parseInt("" + postData.months, 10);
      if (!postData.months) {
        postData.months = undefined;
      }

      return postData;
    }
  },
  computed: {
    rawPostData(): PublishmentCourse {
      return this.course;
    },
    validateUrl(): string {
      return "/api/adv/publishment_courses/validate";
    },
    execUrl(): string {
      return this.course["@id"] || "";
    },
    execMethod() {
      return "put";
    }
  },
  data() {
    return {
      isLoading: true,
      course: {} as PublishmentCourse,
      phase: "input",
      errors: {}
    };
  },
  async mounted() {
    this.course = await this.$store.dispatch("get", [
      "/api/adv/publishment_courses/" + this.$route.params.id
    ]);
    this.isLoading = false;
  }
});
